import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=9eccf31e&"
import script from "./NoContent.vue?vue&type=script&lang=js&"
export * from "./NoContent.vue?vue&type=script&lang=js&"
import style0 from "./NoContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports